import { render, staticRenderFns } from "./ywyjxjs.vue?vue&type=template&id=32028eea&scoped=true"
import script from "./ywyjxjs.vue?vue&type=script&lang=js"
export * from "./ywyjxjs.vue?vue&type=script&lang=js"
import style0 from "./ywyjxjs.vue?vue&type=style&index=0&id=32028eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32028eea",
  null
  
)

export default component.exports